import React from 'react'

const ProductsComponent = (props) => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default ProductsComponent
